module.exports = __webpack_public_path__ + "assets/img/free_10.81618efd.png";